import * as React from 'react';

import { UIHeading1 } from '@cian/ui-kit';

export const DESKTOP_TITLE = <h1>Мой дом — аналитика вашей недвижимости</h1>;
export const MOBILE_TITLE = <UIHeading1 color="theme-black">Мой дом</UIHeading1>;
